import { useParameter } from '../../../shared';

export function useDescription() {
  const [businessUnit] = useParameter('@business-units');
  const descriptionGlobal = [
    'Showing fruits producer prices and consumption per capita in major APE lead countries',
    'Commodities which can be selected include: Apples, Grapes, Pears, Potatoes and Tomatoes',
    'Source: FAO Producer Prices, FAO Population, FAO Food Balance and Global Insight',
  ];
  const descriptionAPE = [
    'Showing fruits producer prices and consumption per capita in major APE lead countries',
    'Commodities which can be selected include: lemon and limes, grapefruit (inc. pomelos), olives, apples, pears and grapes',
    'Source: FAO Producer Prices, FAO Population, FAO Food Balance and Global Insight',
  ];
  return businessUnit === 1 ? descriptionGlobal : descriptionAPE;
}